/**
 * Detail Page - Prediction review interface
 */

import AppLayout from '../components/AppLayout';
import DetailPageLayout from '../components/detail/DetailPageLayout';

export default function DetailPage() {
  return (
    <AppLayout>
      <DetailPageLayout />
    </AppLayout>
  );
}
